import type { ProductCatalogItem } from '../../../../../types/product-catalog';
import type { ProductClientDetails } from '../../../../../types/product-detail';
import type { Obligation } from '../../../../../types/ztb';
import ProductDetailFaqSection from './faq-section';
import ProductDetailFeatureCards from './feature-cards';
import ProductDetailHero from './hero';
import ProductDetailPricingTiers from './pricing-tiers';
import ProductDetailRecommendations from './recommendations';

type Props = {
  item: ProductCatalogItem;
  content: ProductClientDetails;
  obligations: Array<Obligation>;
  recommendedProductIds: Array<string>;
  onContactClick: (item: ProductCatalogItem) => void;
};

const ProductDetailPage = ({ item, content, obligations, recommendedProductIds, onContactClick }: Props) => (
  <div data-ref='buy.product-detail.page'>
    <ProductDetailHero
      item={item}
      breadcrumbLabel={content.breadcrumbLabel}
      heroTitle={content.heroTitle}
      heroImageUrl={content.heroImageUrl}
      aiInsight={content.aiInsight}
      heroPricing={content.heroPricing}
      hasPricing={content.pricingTiers.items.length > 0}
      onContactClick={() => onContactClick(item)}
    />
    <div className='pad-all-xl'>
      <ProductDetailPricingTiers pricingTiers={content.pricingTiers} onContactClick={() => onContactClick(item)} />
      {content.featureSections.map((section, index) => (
        <ProductDetailFeatureCards key={section.heading ?? index} features={section} sectionIndex={index} />
      ))}
      <ProductDetailFaqSection faqs={content.faqs} />
      <ProductDetailRecommendations
        currentProductId={item.id}
        recommendedProductIds={recommendedProductIds}
        obligations={obligations}
        onContactClick={onContactClick}
      />
    </div>
  </div>
);

export default ProductDetailPage;
